module.exports = __webpack_public_path__ + "img/cattunnel27.bd521b49.jpg";